import React, { useState, useEffect } from 'react'
import moment, { Moment } from 'moment-timezone'
import { t } from '../../../i18n'
import { LocalizationContext, LocalizationContextType, DEFAULT_LOCALIZATION_CONTEXT } from '../../shared/contexts'
import TenantDateTimePicker from '../../shared/TenantDateTimePicker'

interface DateTimeFiltersProps {
  localization_context?: LocalizationContextType
}

const DateTimeFilters: React.FC<DateTimeFiltersProps> = ({ localization_context }) => {
  const timezone = localization_context?.timezone || 'UTC'
  const [timeFrom, setTimeFrom] = useState<Moment | null>(null)
  const [timeUntil, setTimeUntil] = useState<Moment | null>(null)

  const getQueryParam = (param) => {
    const url = new URL(location.toString())
    return url.searchParams.get(param) || null
  }

  const initializeFilters = () => {
    const timeFromParam = getQueryParam('time_from')
    setTimeFrom(timeFromParam ? moment.tz(timeFromParam, timezone) : null)

    const timeUntilParam = getQueryParam('time_until')
    setTimeUntil(timeUntilParam ? moment.tz(timeUntilParam, timezone) : null)
  }

  useEffect(() => {
    initializeFilters()
  }, [])

  return (
    <LocalizationContext.Provider value={localization_context || DEFAULT_LOCALIZATION_CONTEXT}>
      <div className='d-inline-block float-end'>
        <TenantDateTimePicker
          className='me-2'
          label={t('scheduler_run_reports.from')}
          value={timeFrom}
          onChange={setTimeFrom}
        />
        <input type='hidden' name='time_from' value={timeFrom ? timeFrom.toISOString() : ''} />
        <TenantDateTimePicker
          label={t('scheduler_run_reports.to')}
          value={timeUntil}
          onChange={setTimeUntil}
        />
        <input type='hidden' name='time_until' value={timeUntil ? timeUntil.toISOString() : ''} />
      </div>
    </LocalizationContext.Provider>
  )
}

export default DateTimeFilters
